import { render, staticRenderFns } from "./addRoom.vue?vue&type=template&id=28e32ca4&scoped=true&"
import script from "./addRoom.vue?vue&type=script&lang=js&"
export * from "./addRoom.vue?vue&type=script&lang=js&"
import style0 from "./addRoom.vue?vue&type=style&index=0&id=28e32ca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e32ca4",
  null
  
)

export default component.exports